/* eslint-disable @next/next/no-img-element */
import { ASSET_PREFIX } from 'utils/constants';

interface IBoostSectionHeadingV2 {
  noIcon?: boolean;
  setShowBoostJackpotPopup: (popup: boolean) => void;
}

export const BoostSectionHeadingV2 = ({
  noIcon = undefined,
  setShowBoostJackpotPopup,
}: IBoostSectionHeadingV2) => {
  return (
    <div className="flexRow">
      {!noIcon && (
        <img
          src={`${ASSET_PREFIX}/images/enter/rocket.png`}
          alt=""
          className="rocketImage actionIcon"
        />
      )}

      <div className="flexRow flexLeftAligned">
        <p className="heading title">
          Boost your{' '}
          <span style={{ whiteSpace: 'nowrap' }}>
            win
            <img
              src={`${ASSET_PREFIX}/images/info-circle.svg`}
              onClick={() => setShowBoostJackpotPopup(true)}
              alt="info"
              className="infoIcon"
            />
          </span>
        </p>
      </div>
      <style jsx>
        {`
          .heading {
            text-align: left;
            margin-left: 0.5em;
            margin-top: 0;
            margin-bottom: 0;
            font-size: '1rem';

            font-weight: 800;
          }

          .rocketImage {
            width: 38px;
            height: 38px;
            margin-right: 0.25rem;
            vertical-align: middle;
            padding: 6.5px;
          }

          .infoIcon {
            margin: 0 0.5em;
            min-width: 15px;
          }
        `}
      </style>
    </div>
  );
};
